import React from 'react';
import { useTranslation } from 'react-i18next';

import { DialogMessageContents, ModalDialog } from '@/components/Elements';

/**
 * プロパティ
 */
type Props = {
  // ダイアログ表示/非表示(true=表示)
  isOpen: boolean;
  // OKボタンクリック処理
  onClickOK: () => void;
};

/**
 * 共有終了ダイアログ コンポーネント
 */
export const ShareInvalidDialog = React.memo(({ isOpen, onClickOK }: Props) => {
  const { t } = useTranslation();

  return (
    <ModalDialog
      isOpen={isOpen}
      title={t('shareInvalidDialog.共有URLを終了しました').toString()}
      buttons={[
        {
          label: t('translationDialog.OK'),
          onClick: onClickOK,
          gtmClassTag: 'dialog-07',
        },
      ]}
    >
      <DialogMessageContents>
        {t('shareInvalidDialog.発行済の共有URLとQRコードが無効となりました。')}
      </DialogMessageContents>
    </ModalDialog>
  );
});
